export const locations = [{
  id: 1227,
  name: "Skien Tungbil",
  url: "https://learnvtskientungbil.tabs.no/kalender",
  classes: ['C1', 'C', 'D1', 'D', 'ADR', 'YDP', 'YDG', 'EYDG', 'EYDPG'],
}, {
  id: 1228,
  name: "Skien og Porsgrunn",
  url: "https://learnvtskienogporsgrunn.tabs.no/kalender",
  classes: ['TG', 'AM146', 'A1', 'A2', 'A', 'B', 'B96', 'BE'],
}, {
  id: 1229,
  name: "Tønsberg Tungbil",
  url: "https://learnvttonsbergtungbil.tabs.no/kalender",
  classes: ['C1', 'C', 'CE', 'D1', 'D', 'EYDG', 'EYDPG'],
}];